import cx from "classnames";

import Image, { ImageProps } from "common/components/Image";

import styles from "../../styles/DoctorImage.module.less";

type DoctorImageProps = Omit<ImageProps, "alt">;

const DoctorImage = ({ className, ...other }: DoctorImageProps) => {
  return <Image alt="Doctor" className={cx(styles.image, className)} {...other} />;
};

export default DoctorImage;
